import { render, staticRenderFns } from "./HomeLayout.vue?vue&type=template&id=c84ff27a"
import script from "./HomeLayout.vue?vue&type=script&lang=js"
export * from "./HomeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports